// import ASMVenues from "../static/ASMVenues.json";

function generateVenueOptionList() {
  let options = [];
  ASMVenues.forEach(function(venue) {
    const sso = venue["SSO"] === "Yes" ? true : false;
    const html = `<option data-sso="${sso}">${venue.Location}</option>`;
    options.push(html);
  });

  return options.join('');
}


export const loginBoxHtml = `
  <div class="loginBox">
    <strong>Access online training:</strong>
    <a href="https://asmg.litmos.com/account/login/" id="login-btn" class="button" target="_blank">Login</a>
  </div>
`;
